import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { getEventTimeSeries } from '../../../services/eventAnalyticsService';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-card border border-border rounded-lg p-3 shadow-lg text-xs">
      <p className="font-semibold text-foreground mb-1">{label}</p>
      {payload?.map(p => (
        <div key={p?.dataKey} className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: p?.color }} />
          <span className="text-muted-foreground capitalize">{p?.dataKey}:</span>
          <span className="font-medium text-foreground">{p?.value?.toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
};

const EventVolumeChart = () => {
  const series = getEventTimeSeries();

  // Merge into single array
  const data = series?.views?.map((v, i) => ({
    date: v?.date,
    views: v?.value,
    submissions: series?.submissions?.[i]?.value,
    payments: series?.payments?.[i]?.value,
  }));

  // Show every 5th label
  const tickFormatter = (val, idx) => (idx % 5 === 0 ? val : '');

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base font-semibold text-foreground">Event Volume</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Views, submissions & payments — last 30 days</p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={data} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="gViews" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#107570" stopOpacity={0.25} />
              <stop offset="95%" stopColor="#107570" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gSubs" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#14b8a6" stopOpacity={0.25} />
              <stop offset="95%" stopColor="#14b8a6" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gPay" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#5eead4" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#5eead4" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="date" tick={{ fontSize: 10, fill: 'var(--color-muted-foreground)' }} tickFormatter={tickFormatter} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 10, fill: 'var(--color-muted-foreground)' }} axisLine={false} tickLine={false} />
          <Tooltip content={<CustomTooltip />} />
          <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 11, paddingTop: 8 }} />
          <Area type="monotone" dataKey="views" stroke="#107570" strokeWidth={2} fill="url(#gViews)" dot={false} />
          <Area type="monotone" dataKey="submissions" stroke="#14b8a6" strokeWidth={2} fill="url(#gSubs)" dot={false} />
          <Area type="monotone" dataKey="payments" stroke="#5eead4" strokeWidth={2} fill="url(#gPay)" dot={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EventVolumeChart;
